@use 'sass:math';
@use '@/sass/variables';

$icon-size: variables.$font-size-4;
// Shared height cap for both panels' bodies (Configuration + Activity). Finite so the collapse
// max-height transition animates; content taller than this scrolls (the body is a flex column, so a
// scrollable child with min-height:0 fills and scrolls within it).
$panel-body-max-height: 60vh;

$panel-width: 26rem;
// Horizontal space one panel occupies from the canvas edge: its own width plus the margin the view
// applies to `.react-flow__panel` (kept in sync with `margin: $spacing-large` in
// AgentSessionView.module.scss — change both together). Exported (below) so the agent view can reserve
// this zone via fitView padding, keeping SCSS the single source of truth for the panel's footprint.
$panel-reserve: $panel-width + variables.$spacing-large;

.panel {
  width: $panel-width;
  background: variables.$white;
  border: 1px solid variables.$gray;
  border-radius: variables.$border-radius-3;
  overflow: hidden;
}

// Emit the panel reserve as a `"<n>px"` string (rem × 16) so JS can pass it straight to React Flow's
// fitView `padding`, which accepts a px-unit string.
:export {
  panelReservePx: #{math.div($panel-reserve, 1rem) * 16}px;
}

.header {
  display: flex;
  align-items: center;
  gap: variables.$spacing-small;
  width: 100%;
  padding: variables.$spacing-medium;
  border: none;
  border-bottom: 1px solid variables.$gray;
  background: variables.$white;
  appearance: none;
  box-shadow: none;
  font-family: inherit;
  font-size: variables.$font-size-4;
  color: variables.$black;
  cursor: pointer;
  text-align: left;
  outline: none;

  // The global legacy stylesheet sets `background`, `border`, and `box-shadow` on `button:focus`.
  // Reset all three so clicking the header leaves no visual change.
  &:focus {
    background: variables.$white;
    border-color: variables.$gray;
    box-shadow: none;
    outline: none;
  }

  &:focus-visible {
    outline: none;
    box-shadow: inset 0 0 0 1px variables.$blue;
  }

  &:hover {
    background: variables.$light-gray;
  }
}

.headerLabel {
  flex: 1 1 auto;
}

.chevron {
  width: $icon-size;
  height: $icon-size;
  color: variables.$mid-gray;
  flex-shrink: 0;
  transition: transform 0.25s ease;
}

.chevronOpen {
  transform: rotate(180deg);
}

.body {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-height: $panel-body-max-height;
  padding: variables.$spacing-medium;
  opacity: 1;
  transition:
    max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.25s ease,
    padding 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.bodyCollapsed {
  max-height: 0;
  opacity: 0;
  padding-top: 0;
  padding-bottom: 0;
}
